import React, { useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { FormControl } from "@mui/material";
import DOMPurify from "dompurify";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Modal from "@mui/material/Modal";
import { useGetRule } from "../../hooks/useRules";
import { checkRuleValue } from "../helpers/helper";
import "../../pages/admin/StudySetup/Questionnaire/FormBuilder/QuestionnaireCss.css";
import { useAlignment } from "../../context/alignmentFormbuilder/AlignmentContext";

const AssignedDrugKit = React.forwardRef((props, ref) => {
  const { Rules, triggerUpdate } = useGetRule();
  const {
    name,
    defaultValue,
    disabled,
    labelAlignment,
    border,
    borderTop,
    borderBottom,
    borderSides,
    hide,
    currentPage,
    label,
  } = props;

  // const [drugOptions, setDrugOptions] = React.useState(
  //   props?.data?.pageTitle?.split(",") || []
  // );
 const { alignment } = useAlignment();
  const [selectedDrugKit, setSelectedDrugKit] = React.useState("");
  const [openModal, setOpenModal] = React.useState(false);
  const [titleName, setTitleName] = React.useState("");
  const [showTitle, setShowTitle] = React.useState(false);
  const [isDisabled, setDisabled] = React.useState(false);
  const [isVisible, setVisible] = React.useState(true);

  const {
    textSize, 
    width: customWidth,
    MaxValue, 
    MinValue,
    subLabel,
    pageTitle
  } = props?.data;
  

  useEffect(() => {
    const { form, formResponse } = Rules;
    if (formResponse) {
      const myId = props?.data.id;
      const formItem = form[myId];
      if (formItem && formItem["dependsOn"] || formItem && formItem["useCalculation"]) {
        const ruleData = checkRuleValue(formItem, formResponse);
        const { isVisible, isDisable } = ruleData;
        setVisible(isVisible);
        setDisabled(isDisable);
      }
    }
  }, [Rules]);
  

  const handleDrugChange = (event) => {
    setSelectedDrugKit(event.target.value);
    if (props?.set) {
      props?.set({ key: props.data.id, value: event.target.value });
    } else {
      console.warn("set function not provided in props");
    }
    triggerUpdate(true);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleShowTitle = () => {
    if (titleName === "") {
      setShowTitle(false);
    } else {
      setShowTitle(true);
    }
  };

  const handleTitleName = (event) => {
    event.preventDefault();
    setTitleName(event.target.value);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "none !important",
    boxShadow: 24,
    borderRadius: "3px",
    p: 3,
  };
  
  const sanitizedLabel = DOMPurify.sanitize(label || "");
  return (
    <>
      {" "}
      {isVisible && (
        <div
          className={`${border ? "borderFullRadius " : ""} ${
            borderTop ? "borderTop " : ""
          } ${borderSides ? "borderSides " : ""} ${
            borderBottom ? "borderBottom " : ""
          } flexCenter`}
        >
          {currentPage && (
            <div className="currentPage">
              {/* Page <p>{currentPage}</p> */}
              {!showTitle ? (
                <>
                  <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={modalStyle}>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginBottom: "2%",
                            }}
                          >
                            <h4>Enter Page Title</h4>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <TextField
                              className="muiTextInput"
                              id="outlined-basic"
                              onChange={handleTitleName}
                              placeholder="Page Title"
                              variant="outlined"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              marginTop: "4%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={handleShowTitle}
                              className="saveTitleBtn"
                            >
                              Save
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Box>
                  </Modal>
                  {/* <button onClick={handleOpenModal} className="addTitleBtn">
                  Add Title
                </button> */}
                  {/* <div className="addTitleBtn">Container Title</div> */}
                </>
              ) : (
                <p>{titleName}</p>
              )}
            </div>
          )}
           <div className={`removeMargin flex ${hide ? "hideComponent" : alignment === "top"
              ? "flex-col "
              : alignment === "left"
              ? "justify-between items-center gap-20"
              : "justify-end items-center gap-5 prevSpace"}`}>
          <Typography
              className={`custom-typography-class ${disabled ? "labelDisabled" : "labelContainer"}`}
              sx={{ mt: 4, mb: 2 }}
              variant="h6"
              component="div"
            >
              {label === "" ? (
              "Assigned Drug Kit"
            ) : (
              <p dangerouslySetInnerHTML={{ __html: sanitizedLabel }} />
            )}
            </Typography>
            <div className={`ageRangeInputBody flex gap-2 ${
              alignment === "top"
                ? ""
                : alignment === "left"
                ? "order-last"
                : ""
            }`}>
              <div>
              <div className="w-[462px]">
                  <Select
                    labelId="demo-simple-select-helper-label "
                    id="demo-simple-select-helper"
                    className="max-w-xl"
                    style={{
                      width: customWidth ? `${customWidth}px` : "230px",
                    }}
                    value={selectedDrugKit}
                    name={name}
                    ref={ref}
                    defaultValue={defaultValue}
                    // disabled={isDisabled}
                    disabled={isDisabled || disabled}
                    onChange={handleDrugChange}
                    inputProps={{
                      "aria-label": "Assigned Drug Kit",
                      className: "custom-input-class",
                    }}
                    InputProps={{
                      className: "custom-second-div-class",
                    }}
                    sx={{
                      "& .MuiSelect-select": {
                        fontSize: textSize ? `${textSize}px !important` : "12px !important"
                      },
                    }}
                    MenuProps={{
                      className: "custom-menu-root",
                    }}
                  >
                    <MenuItem disabled value="" sx={{fontSize: textSize ? `${textSize}px !important` : "12px !important"}}>
                      <em>Assigned Drug Kit</em>
                    </MenuItem>
                    {pageTitle?.split(",").map((value) => (
                      <MenuItem value={value} sx={{fontSize: textSize ? `${textSize}px !important` : "12px !important"}}>{value}</MenuItem>
                    ))}
                  </Select>
              </div>
              {subLabel ? (
                <span className="text-[10px] ml-1">{subLabel}</span>
              ) : (
                ""
              )}
            </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default AssignedDrugKit;
